import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { trackMemberAreaClick } from "@/lib/analytics";
import { memberAreaUrl } from "@/lib/memberUrl";
import { useLandingData } from "@/context/LandingDataContext";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const About = () => {
  const { content } = useLandingData();
  const aboutData = content?.about || {
    overline: "— Cerita Kami",
    title: "Lahir dari cinta terhadap",
    italicTitle: "kecantikan sejati.",
    image: "/brand/about-hero.jpg",
    quote: "Merawat kulit adalah bentuk cinta paling lembut kepada diri sendiri.",
    paragraphs: [
      "DA'VM hadir untuk memberikan pengalaman merawat diri yang mewah dan menenangkan. Kami menggabungkan sains modern dengan kekayaan alam Indonesia untuk menciptakan formula skincare yang lembut, efektif, dan aman untuk pemakaian harian.",
      "Setiap tetes serum, setiap sentuhan krim adalah bagian dari ritual yang mengingatkan Anda: kecantikan bukan tentang kesempurnaan, melainkan tentang merasa nyaman dan percaya diri pada diri sendiri."
    ]
  };

  return (
    <section
      id="tentang"
      data-testid="about-section"
      className="relative bg-[#FDFBF7] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          className="md:col-span-6 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={aboutData.image}
              alt="Ritual perawatan mewah DA'VM"
              data-testid="about-image"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/20 to-transparent" />
          </div>
          <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#FDFBF7] border border-[#E8E3D9] p-6 max-w-[240px] z-10 shadow-lg">
            <p className="font-serif-display italic text-[#8A6E52] text-lg leading-snug">
              &ldquo;{aboutData.quote}&rdquo;
            </p>
          </div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          custom={1}
          className="md:col-span-6"
        >
          <p className="text-xs tracking-[0.4em] uppercase text-[#BCA38F] mb-6">
            {aboutData.overline}
          </p>
          <h2
            data-testid="about-title"
            className="font-serif-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A] font-light"
          >
            {aboutData.title}
            <br />
            <em className="italic font-normal text-[#8A6E52]">
              {aboutData.italicTitle}
            </em>
          </h2>

          <div className="mt-10 space-y-6 text-base md:text-lg text-[#5C5C5C] leading-relaxed">
            {aboutData.paragraphs?.map((para, k) => (
              <p key={k}>{para}</p>
            ))}
          </div>

          <a
            href={memberAreaUrl()}
            onClick={() => trackMemberAreaClick("about")}
            data-testid="about-cta-button"
            className="mt-12 inline-flex items-center gap-3 rounded-full border border-[#1A1A1A] text-[#1A1A1A] px-8 h-14 text-xs tracking-[0.22em] uppercase hover:bg-[#1A1A1A] hover:text-[#FDFBF7] transition-all duration-500 group"
          >
            Belanja di Member Area
            <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
